import { createAction } from "@reduxjs/toolkit"

/**
 * The agent's answer landed as a body: it ends the live turn and the streamed
 * draft it replaces. Lives apart from both slices so each can react to it
 * without importing the other.
 */
export const turnAnswered = createAction<{
  roomJid: string
  messageId: string
  at: number
}>("agentTurn/answered")
